import React, { useEffect, useState } from "react";
import AccordionSection, { AccordionSectionHandle } from "../../utils/accordion/AccordionSection";

type Props = {
    defaultOpen?: boolean;
    sectionRef?: React.RefObject<AccordionSectionHandle | null>;
};

const WelcomeSection: React.FC<Props> = ({ defaultOpen, sectionRef }) => {
    const [html, setHtml] = useState<string>("");

    useEffect(() => {
        const url = new URL("../../config/welcome.html", import.meta.url).toString();
        fetch(url)
            .then(async (r) => setHtml(await r.text()))
            .catch(() => setHtml(""));
    }, []);

    return (
        <AccordionSection title="Welcome" defaultOpen={defaultOpen} ref={sectionRef}>
            {html ? (
                <div dangerouslySetInnerHTML={{ __html: html }} />
            ) : (
                <div style={{ color: "crimson" }}>Welcome content not available.</div>
            )}
        </AccordionSection>
    );
};

export default WelcomeSection;
